import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const commonColor = {
   palatte: {
      primary: '#518FED',
      secondary: '#14D187',
      error: '#FF4267',
      warning: '#FFBF00',
      white: '#ffffff',
      black: '#000000',
      success: '#22C55E',
   },
};

const dark = {
   ...commonColor,
   bodyBgColor: '#F7F8FB',
   componentBgColor: '#FFFFFF',
   navbarBgColor: '#FFFFFF',

   color: {
      color1: commonColor.palatte.black,
      color2: '#1C1F3E',
      color3: '#667085',
   },
   lightColor: {
      color1: '#E1E1E1',
      color2: '#EAF2FF',
   },
   borderColor: {
      color1: '#A9B8CD',
   },
   invertColor: {},
};

const light = {
   ...commonColor,
   bodyBgColor: '#F7F8FB',
   componentBgColor: '#FFFFFF',
   navbarBgColor: '#FFFFFF',

   color: {
      color1: commonColor.palatte.black,
      color2: '#1C1F3E',
      color3: '#667085',
   },
   lightColor: {
      color1: '#E1E1E1',
      color2: '#EAF2FF',
   },
   borderColor: {
      color1: '#A9B8CD',
   },
   invertColor: {},
};

const createPrimaryTheme = (type = 'light') => {
   const themeColors = type === 'light' ? { ...light } : { ...dark };
   let theme = createTheme({
      colors: { ...themeColors },
      palette: {
         primary: {
            main: themeColors.palatte.primary,
         },
         secondary: {
            main: themeColors.palatte.secondary,
         },
         error: {
            main: themeColors.palatte.error,
         },
         success: {
            main: themeColors.palatte.primary,
         },
         warning: {
            main: themeColors.palatte.warning,
         },
         background: {
            paper: themeColors.componentBgColor,
         },
         text: {
            primary: themeColors.color.color2,
            secondary: themeColors.color.color3,
         },
      },
      typography: {
         fontFamily: `'Open Sans', sans-serif`,
         h1: {
            fontSize: '2rem',
            fontWeight: '600',
         },
         h2: {
            fontSize: '1.8rem',
            fontWeight: '600',
         },
         h3: {
            fontSize: '1.6rem',
            fontWeight: '600',
         },
         h4: {
            fontSize: '1.4rem',
            fontWeight: '600',
         },
         h5: {
            fontSize: '1.2rem',
            fontWeight: '600',
         },
         h6: {
            fontSize: '1rem',
            fontWeight: '600',
         },
      },
      components: {
         MuiButton: {
            defaultProps: {
               variant: 'contained',
            },

            styleOverrides: {
               root: {
                  fontSize: '1rem',
                  textTransform: 'capitalize',
                  borderRadius: '0.5rem',

                  '&&&': {
                     boxShadow: 'unset',
                  },
               },

               sizeLarge: {
                  height: '3.5rem',
               },
            },
         },

         MuiInputBase: {
            styleOverrides: {
               root: {
                  '&&&': {
                     borderRadius: '0.5rem',
                  },
               },
            },
         },

         MuiFormGroup: {
            styleOverrides: {
               root: {
                  '&&&': {
                     marginBottom: '1.4rem',
                  },
               },
            },
         },

         MuiLink: {
            defaultProps: {
               underline: 'none',
            },
         },
         MuiTableCell: {
            styleOverrides: {
               root: {
                  '&&&': {
                     borderBottom: '1px solid #ece8e8',
                  },
               },
            },
         },
         MuiTableRow: {
            styleOverrides: {
               root: {
                  '&&&': {
                     borderBottom: '1px solid #ece8e8',
                  },
               },
            },
         },
         MuiPagination: {
            styleOverrides: {
               root: {
                  select: {
                     backgroundColor: '#518FED',
                  },
               },
            },
         },
         MuiTabPanel: {
            styleOverrides: {
               root: {
                  '&&&': {
                     padding: '0 !important',
                     marginTop: '25px',
                  },
               },
            },
         },
         // MuiSwitch: {
         //    styleOverrides: {
         //       root: {
         //          thumb: {
         //             color: '#22C55E',
         //          },
         //          track: {
         //             backgroundColor: '#010b00,',
         //          },
         //       },
         //    },
         // },

         MuiPaginationItem: {
            styleOverrides: {
               root: {
                  '&.Mui-selected': {
                     color: '#fff',
                     backgroundColor: '#518FED',
                  },
               },
            },
         },

         MuiCard: {
            styleOverrides: {
               root: {
                  '&&&': {
                     borderRadius: '2.2rem',
                     boxShadow: '0px 17px 29px 0px rgba(0, 0, 0, 0.04)',
                     border: 'none',
                  },
               },
            },
         },
      },

      breakpoints: {
         values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400,
            sz_1600: 1600,
            sz_1800: 1800,
            sz_1900: 1900,
         },
      },
   });

   theme = responsiveFontSizes(theme);
   return theme;
};

export default createPrimaryTheme;
